<template>
    <div class="form-group col-12 col-lg-12 p-0 mb-0" v-if="!disabledSelect">
        <label class="m-0 font-weight-bold" :for="name">{{ title }}</label>
        <div class="row">
            <div class="col-8 col-sm-8 col-md-8 col-lg-10">
                <select class="form-control"
                        :id="name"
                        :name="name"
                        type="text" :disabled="disabledSelect">
                    <option v-if="nullable" value="">{{ any }}</option>
                    <option v-for="element in elementsData" :value="element[id]" :selected="element[id] == value">
                        {{ element[display_name]}}
                        <span v-if="name==='status'">{{'('+element.transition_name+')'}}</span>
                        <span v-if="display_name_second"> {{ element[display_name_second]}}</span>
                    </option>
                </select>
            </div>
            <div class="col-2 col-sm-2 col-md-2 col-lg-1 m-0 p-0">
                <button :id="'success_'+name" @click="change" class="btn btn-outline-secondary" type="button"
                        :title="$lang('Zapisz')">
                    <i :id="name+'_icon'" :class="classIcon" aria-hidden="true"></i>
                </button>
            </div>
            <div v-if="!disabledSelect" class="col-2 col-sm-2 col-md-2 col-lg-1 m-0 p-0">
                <button type="button" class="btn btn-outline-secondary" :title="$lang('Anuluj')"
                        @click.prevent="cancelEdit">
                    <i class="fa fa-times" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="form-group col-12 col-lg-12 text-input mb-2 p-0" v-else>
        <label class="font-weight-bold mb-0" :for="id">{{ title }}
            <button v-if="editable" :id="'success_'+name" @click="change" class="btn btn-sm" type="button">
                <i :class="classIcon" aria-hidden="true"></i>
            </button>
        </label>
        <br>
        <div v-for="element in elementsData" v-if="element[id] == value && name !== 'status'">
            <span v-if="name !== 'library_id'">
                {{ element[display_name] }}
            </span>
            <a v-else :href="'/task?owner='+value">
                {{ element[display_name] }}
            </a>
            <span v-if="display_name_second">
                {{ element[display_name_second] }}
            </span>
            <span class="ml-1" v-if="get_extra_info_route!==undefined  && get_extra_info_route!==''">
                <library-extra-info-icon
                    :library_id="equal"
                    :get_extra_info_route="get_extra_info_route"
                    :visible="1"
                ></library-extra-info-icon>
            </span>
        </div>

        <div v-for="element in badge_elements" v-if="element['id'] == value && name === 'status'">
            <span :class="'min-badge badge badge-'+badgePrefix+element['id']">
                {{ element[badge_display_name] }}
            </span>
        </div>
        <span v-if="value===''">
            -
        </span>
    </div>
</template>

<script>
    import ShowNotification from "../../mixins/show-notification";

    export default {
        name: "input-select",
        mixins: [ShowNotification],
        props: [
            'title',
            'name',
            'id',
            'url',
            'update_elements_url',
            'nullable',
            'elements',
            'equal',
            'display_name',
            'display_name_second',
            'any',
            'check',
            'editable',
            'badge_elements',
            'badge_display_name',
            'badge_prefix',
            'get_extra_info_route',
        ],
        data() {
            return {
                classIcon: "fa fa-pencil",
                disabledSelect: true,
                value: this.equal,
                elementsData: this.elements,
                badgePrefix: this.badge_prefix ?? ''
            }
        },

        methods: {
            cancelEdit() {
                this.disabledSelect = true;
                this.classIcon = "fa fa-pencil";
            },
            change() {
                if (this.name === 'status') {
                    let self = this;
                    axios.get(self.update_elements_url)
                        .then(function (response) {
                            self.elementsData = response.data;
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                const inpt = $('#' + this.name);
                if (this.disabledSelect) {
                    this.disabledSelect = false;
                    this.classIcon = "fa fa-check";
                } else if (!this.disabledSelect) {
                    var data = {};
                    data[this.name] = inpt.val();
                    axios.post(this.url, data)
                        .then((response) => {
                            const value = JSON.parse(response.config.data);
                            this.value = value[this.name];
                            this.successRequest();
                            this.showNotification('success', 'Zapisano');
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    this.disabledSelect = true;
                    this.classIcon = "fa fa-pencil";
                }
            },
            successRequest() {
                var $el = $('#success_' + this.name),
                    x = 4000,
                    originalBgColor = $el.css("background"),
                    originalFontColor = $el.css("color");
                $el.css("transition", "background-color 1s ease");
                $el.css("transition", "color 1s ease");
                $el.css("background", "var(--primary-to-yellow)");
                $el.css("color", "var(--white-to-black)");

                setTimeout(function () {
                    $el.css("transition", "background-color 0.5s ease");
                    $el.css("transition", "color 0.5s ease");
                    $el.css("background", originalBgColor);
                    $el.css("color", originalFontColor);
                }, x);
            }
        },
    }
</script>

<style scoped>

</style>
